import '../static/css/Navbar.css'
import ClientContact from './[modal]ClientContact'
import { MenuChocolateIcon } from './assets/icons'
import { useEffect, useState } from 'react'

export default function FaiNavbar() {
    const [isExpanded, setIsExpanded] = useState(false)
    const [contactOpen, setContactOpen] = useState(false)
    const targetHome = () => {
        window.location.href = '/'
    }
    
    useEffect(() => {
        const menu = document.querySelector('.fai-menu-md')

        if (menu) {
            menu.classList.toggle('hidden', !isExpanded)
            // menu.classList.toggle('grid', !isExpanded)
        }
    }, [isExpanded])

    const handleContact = () => {
        setContactOpen(true)
    }

    return <>
        {contactOpen && (
            <ClientContact setContactOpen={setContactOpen} />
        )}
        <header className="w-100 fai-navbar bg-[#1d4aa7] shadow-lg">
            <div className="navbar flex justify-evenly w-100 py-5 max-md:justify-around">
                <figure className='fai-logo flex items-center gap-x-3' onClick={() => { targetHome() }}>
                    <img src="fai_logo.png" alt='logo' />
                    <h1> FAI Imoveis </h1>
                </figure>
                <div className="max-[580px]:hidden w-1/3 fai-nav-links flex items-center justify-end gap-x-5">
                    <a className='bg-[#3a64b9] px-5 py-3 rounded-lg cursor-pointer hover:bg-[#3d68be]' href="#"> Sobre </a>
                    <a className='bg-[#3a64b9] px-5 py-3 rounded-lg cursor-pointer hover:bg-[#4472ce]' onClick={() => handleContact()}> Contato </a>
                </div>
            </div>
            
            <div className="min-[580px]:hidden bg-[#2054bd] w-full fai-nav-links grid">
                <ul className='fai-menu-md hidden w-full flex flex-col text-center justify-center '>
                    <a className='p-5 w-full res-navbar-link'>Contato</a>
                    <a className='p-5 w-full res-navbar-link'>Sobre</a>
                </ul>
                <button className='py-3 h-max w-full flex justify-center focus:border-2 focus:border-blue-600' 
                onClick={() => {isExpanded ? setIsExpanded(false) : setIsExpanded(true)}}>
                    <MenuChocolateIcon />
                </button>
            </div>
        </header>
    </>
}